import { Box, styled, StyleSystemProps } from '@withjoy/joykit';

export const StyledContainer = styled(Box)``;
export const StyledTitle = styled(Box)``;

const containerStyles: StyleSystemProps = {
  width: '100%',
  padding: '72px 0px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  cursor: 'pointer',
  backgroundColor: 'rgba(247, 247, 247, 1)'
};

const titleStyles: StyleSystemProps = {
  width: '100%',
  padding: {
    _: '0 1.5rem',
    sm2: '0 30%'
  },
  textAlign: 'center',
  marginBottom: 5
};

export const styles = {
  container: containerStyles,
  title: titleStyles
};
